import type { HostnameType } from '@/api/types';

/** SASADM-0168 — app-facing host types open in a new tab (the Overview tab's long-standing rule). */
export function isClickableHostType(type: HostnameType): boolean {
  return type === 'APP' || type === 'BRAND';
}
